import { format } from "date-fns";

export const formatDateTime = (dateTime = "", dateFormat = "dd/MM/yyyy, p") => {
	// console.log(dateTime, dateFormat);
	if (dateTime) {
		let date = "";
		if (dateTime instanceof Date) {
			date = format(dateTime, dateFormat);
		} else {
			date = format(new Date(dateTime.replace(/-/g, "/")), dateFormat);
		}
		return date;
	} else {
		return "";
	}
};

export const findValue = (val = null, options = []) => {
	let obj = null;
	if (val && (val.constructor.name == "String" || val.constructor.name == "Number")) {
		options.map((i, k) => {
			if (i.value == val) {
				obj = i;
			}
		});
	} else if (val && val.constructor.name == "Array") {
		obj = [];
		val.map((j) => {
			obj.push(findValue(j, options));
		});
	}

	return obj;
};

export const slugify = (text, separator) => {
	text = text.toString().toLowerCase().trim();

	const sets = [
		{ to: "a", from: "[ÀÁÂÃÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶΑΆ]" },
		{ to: "b", from: "[Β]" },
		{ to: "ae", from: "[Ä]" },
		{ to: "c", from: "[ÇĆĈČ]" },
		{ to: "d", from: "[ÐĎĐÞΔ]" },
		{ to: "e", from: "[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆΕΈ]" },
		{ to: "f", from: "[Φ]" },
		{ to: "g", from: "[ĜĞĢǴΓ]" },
		{ to: "h", from: "[ĤḦ]" },
		{ to: "i", from: "[ÌÍÎÏĨĪĮİỈỊΗΉΙΊΪΐ]" },
		{ to: "j", from: "[Ĵ]" },
		{ to: "ij", from: "[Ĳ]" },
		{ to: "k", from: "[ĶΚ]" },
		{ to: "ks", from: "[Ξ]" },
		{ to: "l", from: "[ĹĻĽŁΛ]" },
		{ to: "m", from: "[ḾΜ]" },
		{ to: "n", from: "[ÑŃŅŇΝ]" },
		{ to: "o", from: "[ÒÓÔÕØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠΟΌΩΏ]" },
		{ to: "oe", from: "[ŒÖ]" },
		{ to: "p", from: "[ṕΠ]" },
		{ to: "ps", from: "[Ψ]" },
		{ to: "r", from: "[ŔŖŘΡ]" },
		{ to: "s", from: "[ŚŜŞŠΣς]" },
		{ to: "ss", from: "[ß]" },
		{ to: "t", from: "[ŢŤΤ]" },
		{ to: "th", from: "[Θ]" },
		{ to: "u", from: "[ÙÚÛŨŪŬŮŰŲỤỦỨỪỬỮỰƯΥΎΫΰ]" },
		{ to: "ue", from: "[Ü]" },
		{ to: "w", from: "[ẂŴẀẄ]" },
		{ to: "x", from: "[ẍΧ]" },
		{ to: "y", from: "[ÝŶŸỲỴỶỸ]" },
		{ to: "z", from: "[ŹŻŽΖ]" },
		{ to: "-", from: "[·/_,:;']" },
	];

	sets.forEach((set) => {
		text = text.replace(new RegExp(set.from, "gi"), set.to);
	});

	text = text
		.toString()
		.toLowerCase()
		.replace(/\s+/g, "-") // Replace spaces with -
		.replace(/&/g, "-and-") // Replace & with 'and'
		.replace(/[^\w\-]+/g, "") // Remove all non-word chars
		.replace(/\--+/g, "-") // Replace multiple - with single -
		.replace(/^-+/, "") // Trim - from start of text
		.replace(/-+$/, ""); // Trim - from end of text

	if (typeof separator !== "undefined" && separator !== "-") {
		text = text.replace(/-/g, separator);
	}

	return text;
};

export const handleChange = (e, setValues) => {
	const key = e.target.name;
	const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

	setValues((values) => ({
		...values,
		[key]: value,
	}));
};

export const handleFileChange = (file, name = "image", setValues) => {
	setValues((values) => ({
		...values,
		[name]: file,
	}));
};

// GA & PIXEL
export const makeGAEvent = (action, params = { event_category, event_label, value }) => {
	if (process.env.NODE_ENV == "development") {
		console.log("%cTHIS WILL BE SENT TO GOOGLE ANALYTICS:", "background: #000; color: #bada55");
		// console.log(`%cwindow.gtag("event", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2).replace(/"([^"]+)":/g, "$1:")});`, "color: #bada55");
		console.log(`%cwindow.gtag("event", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2)});`, "color: #bada55");
	} else {
		if (window && window.gtag && typeof window.gtag === "function") {
			// console.log("%cTHIS WILL BE SENT TO GOOGLE ANALYTICS:", "background: #000; color: #bada55");
			// console.log(`%cwindow.gtag("event", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2)});`, "color: #bada55");
			window.gtag("event", action, params);
		}
	}
};

export const makeFBQEvent = (action, params = {}) => {
	if (process.env.NODE_ENV == "development") {
		console.log("%cTHIS WILL BE SENT TO FACEBOOK ANALYTICS:", "background: #000; color: #bada55");
		// console.log(`%cwindow.fbq("track", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2).replace(/"([^"]+)":/g, "$1:")});`, "color: #bada55");
		console.log(`%cwindow.fbq("track", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2)});`, "color: #bada55");
	} else {
		if (window && window.fbq && typeof window.fbq === "function") {
			// console.log("%cTHIS WILL BE SENT TO FACEBOOK ANALYTICS:", "background: #000; color: #bada55");
			// console.log(`%cwindow.fbq("track", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2)});`, "color: #bada55");
			window.fbq("track", action, params);
		}
	}
};
